import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

import "./i18n/i18n.js";
import { installAIGeneratedErrorReporter } from "./utils/installAIGeneratedErrorReporter.js";

installAIGeneratedErrorReporter();

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
